/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_Confirm_DescInputs */

const en_directory_submit_enrich_confirm_desc = /** @type {(inputs: Directory_Submit_Enrich_Confirm_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI will crawl your website and generate the full listing (article, scorecard, both audits), then submit it for review — this uses one submission from your quota. You can publish instantly with Fast Track or wait for free moderation. Takes 1-2 minutes, please keep this dialog open.`)
};

const zh_directory_submit_enrich_confirm_desc = /** @type {(inputs: Directory_Submit_Enrich_Confirm_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 将抓取你的网站并生成完整条目（文章、评分卡、双审计），然后提交审核——这会占用你的一次提交额度。你可以用 Fast Track 立即发布，或等待免费人工审核。约需 1-2 分钟，请保持此窗口打开。`)
};

/**
* | output |
* | --- |
* | "AI will crawl your website and generate the full listing (article, scorecard, both audits), then submit it for review — this uses one submission from your qu..." |
*
* @param {Directory_Submit_Enrich_Confirm_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_confirm_desc = /** @type {((inputs?: Directory_Submit_Enrich_Confirm_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Confirm_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_confirm_desc(inputs)
	return zh_directory_submit_enrich_confirm_desc(inputs)
});
export { directory_submit_enrich_confirm_desc as "directory.submit.enrich.confirm_desc" }